import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { PreviewState } from 'app/pages/laboratory-area/preview/preview-state';
import { PreviewBatchLoaderService } from '../preview-batch-loader.service';

@Injectable({
  providedIn: 'root',
})
export class PreviewService {
  private _activatedRoute = inject(ActivatedRoute);
  private _previewBatchLoaderService = inject(PreviewBatchLoaderService);
  private _previewState: PreviewState;

  public configRouteData(
    command: string,
    previewState: PreviewState,
    documentType: string = '',
  ): { commands: string[]; extras: NavigationExtras } {
    let extras = {};
    const commands = [command];

    if (previewState.uuids!.length > PreviewBatchLoaderService.MAX_BATCH_SIZE) {
      // Store in sessionStorage when > 100 UUIDs
      const docType = documentType || this._extractDocumentTypeFromCommand(command);
      this._previewBatchLoaderService.storeUuids(docType, previewState.uuids);
      this.setPreviewState(previewState);
    } else if (previewState.uuids!.length < PreviewState.maxUuidsLengthFromURL) {
      // Short URL - use pstate query param
      extras = {
        relativeTo: this._activatedRoute,
        queryParams: { pstate: JSON.stringify(previewState) },
        queryParamsHandling: 'merge',
        replaceUrl: false,
        state: { replaceUrlFlag: false },
      };
    } else {
      // URL too long but < 100 - store in memory
      this.setPreviewState(previewState);
    }
    return { commands, extras };
  }

  public getPreviewState(): PreviewState {
    if (this._previewState) {
      return this._previewState;
    }
    return new PreviewState();
  }

  public setPreviewState(previewState: PreviewState): void {
    this._previewState = previewState;
  }

  private _extractDocumentTypeFromCommand(command: string): string {
    // Extract document type from command path like '/preview/invoice' or '/customer-area/preview/delivery-form'
    const parts = command.split('/').filter((p) => p);
    const previewIndex = parts.indexOf('preview');
    if (previewIndex !== -1 && previewIndex + 1 < parts.length) {
      const baseDocType = parts[previewIndex + 1];
      // Prefix with 'customer-' if it's in customer-area
      if (parts.includes('customer-area')) {
        return `customer-${baseDocType}`;
      }
      return baseDocType;
    }
    return 'unknown';
  }
}
